import React from 'react';

import { Option } from './types';
import { InputItem } from './Select.styled';

interface ComponentProps {
  option: Option;
  style?: React.CSSProperties;
  handleInputItemClick: () => Promise<void>;
}

const OptionInputItem: React.FC<ComponentProps> = ({ option, style, handleInputItemClick }) => (
  <InputItem style={style} onClick={handleInputItemClick}>
    {option.selectedRender !== undefined && option.selectedRender}
    {option.selectedRender === undefined && option.selectedLabel !== undefined && option.selectedLabel}
    {option.selectedRender === undefined && option.selectedLabel === undefined && option.label}
  </InputItem>
);

export default OptionInputItem;
